export function getFilterKey(itemCategory, itemKey) {
  return `${itemCategory}-${itemKey}`
}
